import React from 'react';
import { Layout, Tabs, TabPanel } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useIntls from '@opm/hooks/useIntls';
import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import { HashtagPoint } from '@opm/operationLog/pages';
import BubbleCommon from '@op/components/BubbleCommon';
import { hashtagHeaderTipsMap } from '@opm/components/BubbleCommon';
import ScrollBottomList from '@opm/components/ScrollBottomList';
import { ClassSpecial } from '@op/constants/common';
import useTabHistory from '@op/hooks/useTabHistory';
import { useTranslateHashtagCategory } from './hooks';
import TabBar from './tabs';
import { TAB_CONFIG, DEFAULT_TAB } from './tabs/constants';
import './index.scss';

const { Content } = Layout;

function Hashtag() {
  
  const { intl } = useIntls();
  const { backCondConfig, translateCategory } = useTranslateHashtagCategory({
    type: 'hashtag',
  });

  const { tab: activeKey, onActive } = useTabHistory({
    defaultValue: DEFAULT_TAB,
    key: 'tab',
    removeKeys: ["shortid"]
  });

  DBOM_POINT.useInitPage({ buriedPoint: HashtagPoint, pageExtInfo: activeKey});

  const handleTabActive = (tabInfo: { id: string }) => {
    DBOM_POINT.page(tabInfo.id);
    onActive(tabInfo);
  };

  return (
    <ScrollBottomList>
      <Content className="dbom-hashtag">
        <Content.Header
          className="contentHead-normal"
          title={intl({ id: 'Hashtag' })}
          subtitle={
            <div className="dbo-header-subtitle">
              {intl({ id: 'Data Update' })}
              <BubbleCommon showIcon={false} tipsMap={hashtagHeaderTipsMap}>
                <TipContext className="title-tip" placement="bottom" />
              </BubbleCommon>
            </div>
          }
        >
          <div className="header-tab">
            <TabBar activeKey={activeKey} onActive={handleTabActive} />
          </div>
        </Content.Header>
        <Tabs
          className={ClassSpecial.TAB_NONE}
          activeId={activeKey}
          onActive={handleTabActive}
        >
          {TAB_CONFIG.map(tab => (
            <TabPanel key={tab.key} id={tab.key}>
              <tab.component
                backCondConfig={backCondConfig}
                translateCategory={translateCategory}
              />
            </TabPanel>
          ))}
        </Tabs>
      </Content>
    </ScrollBottomList>
  );
}

export default Hashtag;
